const cb_clickTaleEvent = (val) => {
	var action = '';
	switch (val) {
		case 'yes':
			action = 'Clicked Continue to Application';
			break;
		case 'no':
			action = 'Clicked No Thanks';
			break;
		default:
			action = 'Clicked Close';
	}
	if (typeof window['ClickTaleEvent'] == 'function') {
		window['ClickTaleEvent'](`Action | Wells Fargo Offer | ${action}`);
	}
};

const cb_removeWebStorage = () => {
	if (typeof(sessionStorage) != 'undefined') {
		sessionStorage.removeItem('wellsQuickScreenURL');
		sessionStorage.removeItem('offer');
		sessionStorage.removeItem('name');
	} else {
		$.removeCookie('wellsQuickScreenURL', {
			path: '/',
			domain: false,
		});
		$.removeCookie('name', {
			path: '/',
			domain: false,
		});
		$.removeCookie('offer', {
			path: '/',
			domain: false,
		});
	}
};

const cb_modalFunctions = (val, offer) => {
	cb_clickTaleEvent(val);
	manualLinkClick(`/wells-fargo?cm_sp=quickscreen-_-${offer}-_-${val}`);
};

const cb_modalChange = (title, section) => {
	$('.modal-title').html(title);
	$(section).show();
};

const citibankSpeedbump = (params, returnHTML) => {
	var myCallback = () => {
		var newCitiLink = '';
		let link = params.citiLink;

		if (window.location.href.indexOf("cmp") > -1) {
			//handle for multiple query params
			let cmpTag = window.location.href.split("cmp=")[1];
			if (cmpTag.includes("&")) {
				cmpTag = cmpTag.split("&")[0];
			}

			if (link.includes("cmp")) {
				let oldLinkFront = link.split("cmp=")[0];				
				let oldLinkBack = link.split("cmp=")[1];
				if (oldLinkBack.includes("&")) {									
					let queryParams = oldLinkBack.split("&")[1];
					link = oldLinkFront + "cmp=" + cmpTag + "&" + queryParams;
				} else {
					link = oldLinkFront + "cmp=" + cmpTag;
				}				
			} else {
				if (link.includes("?")) {
					link += "&cmp=";
					link += cmpTag;
				} else {
					link += "?cmp=";
					link += cmpTag;
				}	
			}
		}

		if (params != undefined) {
			newCitiLink = `window.open('${link}', 'citiApp')`;
		}

		$('.citiLinkName').attr('onclick', `${newCitiLink};$('#dynamicModalContainer button')[0].click();`);
		cb_removeWebStorage();
	};
	$.ajax({
		cache: true,
		type: "GET",
		dataType: "json",
		url: "/webapp/wcs/stores/servlet/NonCacheESpot",
		data: "emsName=ES_SPEEDBUMP_MODAL_CARDHOLDER_MSG&maxNumDisp=1&storeId=301&catalogId=301&langId=-1",
		success: function (json) {
			returnHTML(json.JSON.eSpotContent0, myCallback);
			return false;
		},
	});
};

const citibankOffer = (params, returnHTML) => {
	var myCallback = () => {
		$('.wf-footer').detach().appendTo('.modal-content');
		$('.wellsLinkName').attr('onclick', decodeURIComponent(Dillards.getCookieOrWebStorage('wellsQuickScreenURL')) + ';');
		let wf_offer = Dillards.getCookieOrWebStorage('offer'),
			wf_name = Dillards.getCookieOrWebStorage('name');
		var linkClicked = false,
			wf_elementID = '';
		$('.wfCmTrack').on('click', function (e) {
			e.preventDefault(); // prevent default behavior
			let wfval = $(this).data('wfval');
			linkClicked = true;
			cb_modalFunctions(wfval, wf_offer, wf_name);
		});
		$('#dynamicModalContainer').on('shown.bs.modal', function () {
			$('.wells-fargo-offer').on('hidden.bs.modal', function () {
				if (!linkClicked) cb_modalFunctions('close', wf_offer, wf_name);
				cb_removeWebStorage();
			});
		});
		switch (wf_offer) {
			case '01':
				cb_modalChange("Be rewarded today with <span class='openSansBold'>FREE SHIPPING!<sup>1</sup>", '.wells-free-shipping');
				break;
			case '02':
				cb_modalChange("Would you like to earn <span class='openSansBold'>REWARDS POINTS</span> today?", '.wells-reg');
				break;
			case '03':
				cb_modalChange("Be rewarded today with <span class='openSansBold'>10% OFF</span> your purchase!<sup>1</sup>", '.wells-ten-off');
				break;
			case '04':
				cb_modalChange(
					"Be rewarded today with <span class='openSansBold'>10% OFF</span><sup>1</sup> your entire order and <span class='openSansBold'>FREE SHIPPING!<sup>2</sup>",
					'.wells-free-ship-ten-off'
				);
				break;
			default:
				break;
		}
	};
	$.ajax({
		url: '/static/html/modals/_wells-fargo-offer-modal.html',
		success: function (html) {
			returnHTML(html, myCallback);
			return false;
		},
	});
};

export { cb_removeWebStorage, citibankSpeedbump, citibankOffer };
